export default "__VITE_ASSET__BuneAfAU__"